export default "__VITE_ASSET__Bsef4A02__"